import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { SharedModule } from 'src/app/shared/shared.module';
import { AcessoNegadoComponent } from './components/acesso-negado/acesso-negado.component';
import { AdesaoPlanoFamiliaComponent } from './components/adesao-plano-familia/adesao-plano-familia.component';
import { DeclaracaoComponent } from './components/declaracao/declaracao.component';
import { FormularioJantarComponent } from './components/formulario-jantar/formulario-jantar.component';
import { LoginComponent } from './components/login/login.component';
import { RedeCredenciadaPublicaComponent } from './components/rede-credenciada/rede-credenciada.component';
import { SimuladorPlanoFamiliaComponent } from './components/simulador-plano-familia/simulador-plano-familia.component';
import { PublicoRoutingModule } from './publico-routing.module';
const maskConfig: Partial<IConfig> = {
  validation: false,
};
@NgModule({
  imports: [
    CommonModule,
    FontAwesomeModule,
    MatTabsModule,
    NgSelectModule,
    PublicoRoutingModule,
    ReactiveFormsModule,
    PdfViewerModule,
    SharedModule,
    NgxMaskModule.forRoot(maskConfig),
    NgbModule,
  ],
  declarations: [
    AcessoNegadoComponent,
    FormularioJantarComponent,
    LoginComponent,
    AdesaoPlanoFamiliaComponent,
    RedeCredenciadaPublicaComponent,
    SimuladorPlanoFamiliaComponent,
    DeclaracaoComponent
  ],
  providers: [
    DatePipe,
  ]
})
export class PublicoModule { }
